<template>
  <div id="app">
    <header>
      <app-header/>
    </header>
    <main>
      <router-view :key="$route.fullPath"/>
    </main>
    <footer class="footer">
      <a href="https://httpain.com/projects">&larr; Back to main site</a>
    </footer>
  </div>
</template>

<script>
  import AppHeader from "./components/AppHeader";

  export default {
    components: {AppHeader}
  }
</script>

<style lang="scss">
  @import "css/fonts.css";
  @import "~sanitize.css";

  html {
    font-family: 'PT Sans', sans-serif;
    color: #333;
    font-size: 16px;
    line-height: 1.4;
  }

  body {
    overflow-y: scroll;
  }

  a, a:visited {
    color: hsl(204, 60%, 30%);
    text-decoration: none;
    padding: 0 3px;
  }

  .header {
    margin: 12px auto;
    padding: 0 12px;
  }

  .footer {
    margin: 64px auto 0;
    padding: 24px 12px;

    a {
      border-bottom: 1px solid hsl(204, 30%, 85%);
    }
  }

  main {
    max-width: 1860px;
    margin: 0 auto;
  }

  @media(min-width: 450px) {
    .header, .footer {
      max-width: 450px;
    }
  }

  @media(min-width: 920px) {
    .header, .footer {
      max-width: 920px;
    }
  }

  @media(min-width: 1390px) {
    .header, .footer {
      max-width: 1390px;
    }
  }

  @media(min-width: 1860px) {
    .header, .footer {
      max-width: 1860px;
    }
  }

</style>
